angular.module('impactx.search').controller('SearchListTenderPreSetCtrl', SearchListTenderPreSetCtrl);

SearchListTenderPreSetCtrl.$inject = ['OneTimeDataTransporter', 'AppConfiguration', 'ToolbarService'];

function SearchListTenderPreSetCtrl(OneTimeDataTransporter, AppConfiguration, ToolbarService) {
    var self = this;
    self.showResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    self.tenders = OneTimeDataTransporter.getData();
    self.numberOfTenders = self.tenders.length;
    self.trns = OneTimeDataTransporter.getTrns();

    var buttonDefinition = [];
    ToolbarService.setButtons(buttonDefinition);
}